import {
  Layers,
  Paintbrush,
  PaintRoller,
  DoorOpen,
  Building2,
  Hammer,
  HardHat,
  Ruler,
  Wrench,
  Home,
  Brush,
} from "lucide-react";

export const ICON_COMPONENTS = {
  Layers,
  Paintbrush,
  PaintRoller,
  DoorOpen,
  Building2,
  Hammer,
  HardHat,
  Ruler,
  Wrench,
  Home,
  Brush,
};

export const SERVICE_ICONS = [
  { value: "Layers", label: "Trockenbau / Wände" },
  { value: "PaintRoller", label: "Verputzen / Streichen" },
  { value: "Paintbrush", label: "Malerarbeiten" },
  { value: "DoorOpen", label: "Innenausbau / Türen" },
  { value: "Building2", label: "Altbau / Gebäude" },
  { value: "Hammer", label: "Handwerk allgemein" },
  { value: "HardHat", label: "Baustelle" },
  { value: "Ruler", label: "Vermessung / Planung" },
  { value: "Wrench", label: "Reparatur" },
  { value: "Home", label: "Wohnen / Zuhause" },
  { value: "Brush", label: "Feinarbeit" },
];
